// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3320G","selected":"Chip_selected__1ZdvO"};